// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__u1s0S"};